import { MyDrive } from '@xver/@types/my-drive';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    GET: '/v1/my-drive',
};

export function getMyDrive(): Promise<MyDrive> {
    return httpClient.get(ENDPOINTS.GET);
}
